import { postDataWithParams } from 'src/consumer/services/profileService'

export async function postTimerData(dataToSend, src, srcId) {
  return await postDataWithParams(`/api/secure/v2/user-meditation-session`, dataToSend, {
    src,
    'src-id': srcId,
  })
}

export function getTimerCompletionDetails(timerType, duration, minDuration, currentDuration) {
  if (timerType === 'fixed') {
    return currentDuration > duration
  }
  if (timerType === 'range') {
    return currentDuration > minDuration
  }
  return true
}
